module.exports = __webpack_public_path__ + "static/media/Institut_teknologi_bandung_logo.a5599595.png";